const listBreadcrumb = {
  text: 'route.list',
  to: 'list',
  link: true
}

export default [
  {
    path: '/logs/sync',
    name: 'LogsSync',
    component: () => import('@/views/Logs.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.logs.sync',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/logs/changes',
    name: 'LogsChanges',
    component: () => import('@/views/Logs.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.logs.changes',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/logs/new',
    name: 'LogsNew',
    component: () => import('@/views/Logs.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.logs.new',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/logs/expired',
    name: 'LogsExpired',
    component: () => import('@/views/Logs.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.logs.expired',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/logs/undistributed-courses',
    name: 'LogsUndistributedCourses',
    component: () => import('@/views/Logs.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.logs.undistributed.courses',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/logs/undistributed-program-areas',
    name: 'LogsUndistributedProgramAreas',
    component: () => import('@/views/Logs.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.logs.undistributed.programAreas',
          disabled: true
        }
      ]
    }
  }
]
